import { InvisibleButton } from '@/widgets/components/invisible-button';
import { Drawer } from 'rsuite';
import styled from 'styled-components';
import { BaseFlex as Flex } from './search-styles';

export const StyledDrawer = styled(Drawer)`
  .rs-drawer-dialog {
    opacity: 0.7;
    backdrop-filter: blur(20px);
  }

  .rs-drawer-content {
    background-color: black;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Header = styled(Flex)`
  height: 30px;
  width: 100%;
  margin-right: 120px;
  margin-top: 60px;
  justify-content: flex-end;
`;

export const CloseButton = styled(InvisibleButton)`
  padding: 0;
  margin: 0;
  width: 40px;
  height: 40px;
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' width='1em' height='1em' style='-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);' preserveAspectRatio='xMidYMid meet' viewBox='0 0 1024 1024'%3E%3Cpath d='M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8L295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512L196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1l216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z' fill='%23ffffff'/%3E%3C/svg%3E");
`;
